import { useState } from 'react';

import { PRIVACY_POLICY, TERMS_AND_CONDITIONS, DPA } from 'src/constants/policies.constants';
import { useOptimizedBooleanState } from 'src/hooks';

import { Chat } from '../OnboardingLayout/Chat';
import { OnboardingCustomerDashboard } from '../OnboardingLayout/OnboardingCustomerDashboard';
import { OnboardingLayout } from '../OnboardingLayout/OnboardingLayout';
import { OnboardingQuote } from '../OnboardingLayout/OnboardingQuote';
import { ConfirmEmailForm } from './ConfirmEmailForm';
import { Anchor, PolicyParagraph } from './OnboardingStepAccount.styles';
import { VerifyEmailForm } from './VerifyEmailForm';

export const OnboardingStepAccount = () => {
  const [isConfirmForm, {
    setTrueCallback: showConfirmForm, setFalseCallback: showVerifyForm,
  }] = useOptimizedBooleanState(false);
  const [email, setEmail] = useState('');
  return (
    <OnboardingLayout
      title={isConfirmForm ? 'Confirm your email' : 'Set up your account'}
      aside={(
        <>
          {isConfirmForm ? <OnboardingQuote user="shreyas" /> : <OnboardingCustomerDashboard />}
        </>
      )}
      main={(
        <>
          {isConfirmForm
            ? <ConfirmEmailForm email={email} onBack={showVerifyForm} />
            : (
              <VerifyEmailForm
                defaultValue={email}
                onSuccess={(emailValue) => {
                  setEmail(emailValue);
                  showConfirmForm();
                }}
              />
            )}
        </>
      )}
      root={!isConfirmForm && <Chat />}
      footer={!isConfirmForm && (
        <PolicyParagraph>
          By submitting this form, you agree to
          {' '}
          <Anchor
            href={TERMS_AND_CONDITIONS}
            target="_blank"
          >
            Cycle’s Terms of Use
          </Anchor>
          ,
          {' '}
          <Anchor
            href={PRIVACY_POLICY}
            target="_blank"
          >
            Privacy Policy
          </Anchor>
          {' '}
          and
          {' '}
          <Anchor
            href={DPA}
            target="_blank"
          >
            Data Processing Agreement
          </Anchor>
          . You also consent to receive personalized marketing communications from which you may unsubscribe at any time.
        </PolicyParagraph>
      )}
    />
  );
};
